export const ActivityHeartbeat: React.FC<
  React.SVGAttributes<SVGSVGElement>
> = props => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 110 110"
    fill="#003057"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M28.00,60.25L28.85,60.17L29.67,59.91L30.42,59.50L31.07,58.94L31.60,58.26L31.98,57.50L39.25,38.11L51.88,87.07L52.18,87.86L52.62,88.57L53.19,89.19L53.87,89.68L54.64,90.03L55.46,90.22L56.30,90.24L57.13,90.10L57.92,89.80L58.63,89.34L59.24,88.76L59.72,88.07L60.05,87.29L71.31,51.90L75.42,58.30L75.95,58.97L76.60,59.51L77.35,59.92L78.16,60.17L79.00,60.25L104.00,60.25L104.83,60.17L105.63,59.93L106.36,59.54L107.01,59.01L107.53,58.36L107.93,57.63L108.17,56.83L108.25,56.00L108.17,55.17L107.93,54.38L107.53,53.64L107.01,53.00L106.36,52.47L105.63,52.08L104.83,51.84L104.00,51.75L81.32,51.75L73.58,39.71L73.08,39.08L72.48,38.55L71.79,38.15L71.03,37.88L70.24,37.76L69.44,37.79L68.66,37.97L67.93,38.29L67.27,38.75L66.71,39.31L66.26,39.98L65.95,40.71L56.43,70.65L44.12,22.94L43.83,22.17L43.40,21.46L42.85,20.85L42.18,20.36L41.44,20.00L40.64,19.80L39.81,19.76L38.99,19.87L38.21,20.15L37.50,20.56L36.88,21.11L36.38,21.77L36.02,22.51L25.05,51.75L6.00,51.75L5.17,51.84L4.37,52.08L3.64,52.47L2.99,53.00L2.47,53.64L2.07,54.38L1.83,55.17L1.75,56.00L1.83,56.83L2.07,57.63L2.47,58.36L2.99,59.01L3.64,59.54L4.37,59.93L5.17,60.17L6.00,60.25Z"
    />
  </svg>
)
